import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EOIsTable from "../../components/EOIs/EOIsTable";




const EOIsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="EOIs" />

       {/* Projects Table */}
        <EOIsTable />   

      </MasterLayout>
    </>
  );
};

export default EOIsPage;
